/**************************************************
 * Nombre:       Tarjeta_Sola_Asesoria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Grid2, Typography} from "@mui/material";
import enbudo from "../../Recursos/enudo.svg";
import maletin from "../../Recursos/maletin.svg";

const Tarjeta_Sola_Asesoria = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                <img src={maletin} width={32} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                <Typography sx={{textAlign: 'center', fontWeight: 400,fontSize: 20}}>
                    Asesoría práctica y personalizada para <span
                    style={{fontWeight: 600}}>construir una marca sólida y exitosa.</span>
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Sola_Asesoria